import { BlensTickers } from "~types/types";

export const fetchBlensTickersByQuoteIds = async (
    quoteIds: string[]
): Promise<BlensTickers> => {
    const quoteIdsString = encodeURIComponent(quoteIds.join(",")).replace(
        "%2F",
        "%252F"
    );
    const response = await fetch(`/article/api/blens/${quoteIdsString}`);

    if (!response.ok) {
        console.log(`Error fetching blens tickers: ${quoteIdsString}`);
        return [];
    }

    return response.json();
};
